import { Power4, gsap } from "gsap";

export const manufacturerItemsAnimation = () => {
    const tl = gsap.timeline({
        defaults: {
            duration: 0.5,
            ease: Power4.easeInOut,
        },
    });

    tl.fromTo(
        ".logo",
        {
            y: -10,
            opacity: 0,
        },
        {
            y: 0,
            opacity: 1,
        },
        "<0.25",
    )
        .fromTo(
            ".title",
            {
                y: -50,
                opacity: 0,
            },
            {
                y: 0,
                opacity: 1,
            },
            "<0.25",
        )
        .fromTo(
            ".description",
            {
                y: 20,
                opacity: 0,
            },
            {
                y: 0,
                opacity: 1,
            },
            "<0.25",
        )
        .fromTo(
            ".arrows",
            {
                y: -50,
                opacity: 0,
            },
            {
                y: 0,
                opacity: 1,
            },
            "-=1",
        );
    return tl;
};
